import { CASHIER_ROLES } from '../../../../../common/core/_consts'
import { ROLE } from '../../../../auth'

/** Who sees requisites: the lists, the requisite card, its balance operations and its change history. */
export const REQUISITE_VIEW_ROLES = [...CASHIER_ROLES, ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER]

/**
 * Who changes requisites: create, edit, enable/disable, reservation, client binding, manual balance operation,
 * client transfer. The merchant payments operator only reads them — the backend refuses its writes.
 */
export const REQUISITE_WRITE_ROLES = [...CASHIER_ROLES, ROLE.ROLE_MERCHANT_MANAGER]

/** Who hides a requisite: the manager (the admin inherits it) and the merchant manager — the backend's hide gate. */
export const REQUISITE_HIDE_ROLES = [ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]
